// extracted by mini-css-extract-plugin
export default {"mainDiv":"AutoSubmitPopup_mainDiv__5qNA3","container":"AutoSubmitPopup_container__7xH3b","button":"AutoSubmitPopup_button__9MXn-"};